import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  autoRefresh: false,
  validations: [],
  selectedItem: [],
  dbSrc: 'prd',
  searchTerm: '',
  searchType: 'All',
};

const dataSlice = createSlice({
  name: 'dataSlice',
  initialState,
  reducers: {
    setAutoRefresh(state, action) {
      state.autoRefresh = action.payload;
    },
    setValidations(state, action) {
      state.validations = action.payload;
    },
    setSelectedItem(state, action) {
      state.selectedItem = action.payload;
    },
    setDbSrc(state, action) {
      state.dbSrc = action.payload;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    setSearchType(state, action) {
      state.searchType = action.payload;
    },
  }
});

export const {
  setAutoRefresh,
  setValidations,
  setSelectedItem,
  setDbSrc,
  setSearchTerm,
  setSearchType,
} = dataSlice.actions;

export default dataSlice.reducer;
